import {
  Directive,
  ElementRef,
  HostListener,
  Input,
  Renderer2,
} from '@angular/core';

@Directive({
  selector: '[appTooltip]',
  standalone: true,
})
export class TooltipDirective {
  @Input('appTooltip') tooltipText = '';
  @Input() appTooltipShowDelay: number = 500;
  @Input() appTooltipDisabled: boolean = false;
  @Input() appTooltipPosition: 'top' | 'bottom' | 'left' | 'right' = 'top';

  private tooltipEl?: HTMLElement;
  private timeoutRef: any;

  constructor(private el: ElementRef, private renderer: Renderer2) {}

  @HostListener('mouseenter')
  @HostListener('focus')
  showTooltip() {
    if (this.appTooltipDisabled || !this.tooltipText || this.tooltipEl) return;

    this.timeoutRef = setTimeout(() => {
      this.createTooltip();
    }, this.appTooltipShowDelay);
  }

  @HostListener('mouseleave')
  @HostListener('blur')
  hideTooltip() {
    clearTimeout(this.timeoutRef);
    this.removeTooltip();
  }

  private createTooltip() {
    if (this.tooltipEl) return;

    const host = this.el.nativeElement as HTMLElement;
    const tooltip = this.renderer.createElement('span');

    tooltip.innerText = this.tooltipText;

    this.renderer.addClass(tooltip, 'app-tooltip');
    this.renderer.addClass(tooltip, `app-tooltip-${this.appTooltipPosition}`);

    this.renderer.appendChild(host, tooltip);
    this.tooltipEl = tooltip;

    requestAnimationFrame(() => this.positionTooltip(host, tooltip));
  }

  private positionTooltip(host: HTMLElement, tooltip: HTMLElement) {
    const hostRect = host.getBoundingClientRect();
    const ttRect = tooltip.getBoundingClientRect();

    const offset = 6;

    switch (this.appTooltipPosition) {
      case 'top':
        tooltip.style.left = `${hostRect.width / 2 - ttRect.width / 2}px`;
        tooltip.style.bottom = `${hostRect.height + offset}px`;
        break;

      case 'bottom':
        tooltip.style.left = `${hostRect.width / 2 - ttRect.width / 2}px`;
        tooltip.style.top = `${hostRect.height + offset}px`;
        break;

      case 'left':
        tooltip.style.right = `${hostRect.width + offset}px`;
        tooltip.style.top = `${hostRect.height / 2 - ttRect.height / 2}px`;
        break;

      case 'right':
        tooltip.style.left = `${hostRect.width + offset}px`;
        tooltip.style.top = `${hostRect.height / 2 - ttRect.height / 2}px`;
        break;
    }
  }

  private removeTooltip() {
    if (!this.tooltipEl) return;
    this.renderer.removeChild(this.el.nativeElement, this.tooltipEl);
    this.tooltipEl = undefined;
  }
}
